<template>
  <div>
    <top-navbar></top-navbar>

    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right"></i></span>
        <span class="decoration">Employee</span>
        <span class="pfimg3"><i class="fa fa-angle-right"></i></span>
        <span class="decoration">Learning</span>
        <span class="pfimg3"><i class="fa fa-angle-right"></i></span>
        <router-link class="decoration" to="/job/desindex"
          >Manage Job Descriptions</router-link
        >
        <span class="pfimg3"><i class="fa fa-angle-right"></i></span>
        Create Job Description
      </h6>

      <div class="container-fluid">
        <div class="d-flex justify-content-end mb-2"></div>

        <div class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body">
            <form @submit.prevent="createJob">
              <div v-if="message" class="alert alert-success py-2">
                {{ message }}
              </div>
              <div v-if="errorMessage" class="alert alert-danger py-2">
                {{ errorMessage }}
              </div>

              <div class="row mb-3">
                <div class="col-md-3">
                  <label class="custom-label" style="font-size: small"
                    >Job Title <span class="text-danger">*</span></label
                  >
                  <input
                    v-model="jobTitle"
                    class="form-control form-control-sm bdr-rad font-size_def"
                    required
                  />
                </div>
                <div class="col-md-3">
                  <label class="custom-label" style="font-size: small"
                    >Job Description <span class="text-danger">*</span></label
                  >
                  <textarea
                    v-model="jobDescription"
                    class="form-control form-control-sm bdr-rad font-size_def"
                    rows="2"
                    required
                  ></textarea>
                </div>
              </div>

              <div class="card custom_bdr_rds">
                <div class="card-body custom_bdr_rds">
                  <h6 class="purchitem mb-2"><b>Job Files and Links</b></h6>
                  <div class="table-responsive mb-1">
                    <table
                      style="font-size: small"
                      class="table table-sm table-hover"
                    >
                      <thead class="background_color2">
                        <tr class="custom-label2">
                          <th style="width: 50px">#</th>
                          <th>File Upload</th>
                          <th>Links</th>
                          <th style="width: 50px"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, index) in rows" :key="row.key">
                          <td>{{ index + 1 }}</td>
                          <td>
                            <input
                              type="file"
                              class="form-control form-control-sm bdr-rad font-size_def"
                              @change="setFile($event, row)"
                            />
                            <a
                              v-if="row.file && row.filePreviewUrl"
                              :href="row.filePreviewUrl"
                              target="_blank"
                              rel="noopener noreferrer"
                              class="d-inline-block mt-1 small text-primary"
                            >
                              {{ fileName(row.file.name) }}
                            </a>
                          </td>
                          <td>
                            <input
                              v-model="row.link"
                              type="url"
                              class="form-control form-control-sm bdr-rad font-size_def"
                            />
                          </td>
                          <td class="text-nowrap custom-icon">
                            <b-icon
                              @click="removeRow(index)"
                              v-show="rows.length > 1"
                              class="ms-3 me-3 mt-2"
                              width="8"
                              type="button"
                              icon="dash-lg"
                              scale="2"
                              variant=""
                            ></b-icon
                            ><b-icon
                              v-if="index === rows.length - 1"
                              @click="addRow"
                              class="mt-2"
                              width="8"
                              type="button"
                              icon="plus-lg"
                              scale="2"
                              variant=""
                            ></b-icon>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="d-flex justify-content-end mt-3">
                <button
                  type="submit"
                  class="btn btn-sm btn-outline-primary font-size_def bdr-rad"
                  :disabled="isSaving"
                >
                  {{ isSaving ? "Saving..." : "Create" }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from "axios";
import authService from "@/auth.service";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";

export default {
  components: { TopNavbar, ContentFooter },
  data() {
    return {
      token: authService.isLoggedIn(),
      jobTitle: "",
      jobDescription: "",
      rows: [this.newRow()],
      message: "",
      errorMessage: "",
      isSaving: false,
    };
  },
  methods: {
    newRow() {
      return {
        key: Date.now() + Math.random(),
        file: null,
        filePreviewUrl: "",
        link: "",
      };
    },
    addRow() {
      this.rows.push(this.newRow());
    },
    removeRow(index) {
      if (this.rows.length > 1) this.rows.splice(index, 1);
    },
    setFile(event, row) {
      row.file = event.target.files[0] || null;
      if (row.filePreviewUrl) URL.revokeObjectURL(row.filePreviewUrl);
      row.filePreviewUrl = row.file ? URL.createObjectURL(row.file) : "";
    },
    fileName(file) {
      return file || "Uploaded file";
    },
    async createJob() {
      if (!this.jobTitle.trim() || !this.jobDescription.trim()) {
        this.errorMessage = "Job Title and Job Description are required.";
        return;
      }
      this.isSaving = true;
      this.message = "";
      this.errorMessage = "";
      const formData = new FormData();
      formData.append(
        "payload",
        JSON.stringify({
          mode: "description",
          employee_id: "",
          job_title: this.jobTitle,
          job_description: this.jobDescription,
          rows: this.rows.map((row) => ({ selected: false, link: row.link })),
        })
      );
      this.rows.forEach((row, index) => {
        if (row.file) formData.append("job_files[" + index + "]", row.file);
      });
      try {
        const { data } = await axios.post("/ticourses/jobdiscreate", formData, {
          headers: { Authorization: "Bearer " + this.token },
        });
        console.log(data);
        if (!data || !data.message || !data.job_id) {
          const backendResponse = data ? JSON.stringify(data) : "Empty response";
          if (data && data.status === 422 && data.message) {
            throw new Error(data.message + " Errors: " + JSON.stringify(data.errors || {}));
          }
          const routeMessage = data && data.status === 200 && Array.isArray(data.data)
            ? "Server returned the job list response instead of the create response. Deploy the updated POST /api/ticourses/jobs route and TicoursesController.php to the server."
            : "Backend did not return a save confirmation.";
          console.error("[JobDescriptionCreate] Backend did not confirm save", data);
          throw new Error(routeMessage + " Response: " + backendResponse);
        }
        this.message = data.message + " ID: " + data.job_id;
        this.errorMessage = "";
        this.jobTitle = "";
        this.jobDescription = "";
        setTimeout(() => this.$router.push("/job/desindex"), 500);
      } catch (error) {
        console.error("[JobDescriptionCreate] Backend error", {
          status: error.response ? error.response.status : null,
          response: error.response ? error.response.data : null,
          message: error.message,
          error,
        });
        this.errorMessage =
          (error.response &&
            error.response.data &&
            (error.response.data.message || error.response.data.error)) ||
          error.message ||
          "Unable to save job.";
      } finally {
        this.isSaving = false;
      }
    },
    goBack() {
      this.$router.push("/job/create");
    },
  },
};
</script>
